export default "__VITE_ASSET__Bpjb$KoZ__"